import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { CircleAlert } from "lucide-react";

export const CancelledOrdersAlert = () => (
  <Tooltip
    openDelay={200}
    closeDelay={100}
    positioning={{ placement: "bottom" }}
    content={<Text fontSize="14px">Esta solicitud contiene pedidos cancelados</Text>}
       contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
  >
    <CircleAlert
      size={16}
      color={AppColors.RED_ICON_ALT}
      cursor="pointer"
      data-testid="cancelled-orders-alert"
    />
  </Tooltip>
);
